import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ServiceIcon {
  src: string;
  alt: string;
}

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() icons: ServiceIcon[] = [];
  @Input() actions?: boolean = false; // ヘッダーアクション表示フラグ
}